<section class="py-4 mechknow-main-body">
    <div class="container">
        
    <div class="row">

    <div class="col-md-3 mb-3">

    <ul class="nav nav-tabsa custom-tabsa border-0 flex-column bg-white rounded overflow-hidden shadow-sm p-2 c-t-order" id="myTab" role="tablist">
    
        <li>   <a class="cursor-pointer" (click)="homeClick()"><i class="feather-home mr-2" style="font-size:25px;color:#f00;"></i>Back to Home.</a>
        </li>
        <li class="nav-item border-top" role="presentation">
    <a   [ngClass]="[currentPage === 'Completed' ? 'nav-link border-0 text-dark py-3 active' : 'nav-link border-0 text-dark py-3']"  id="completed-tab"  data-toggle="tab" (click)="delivered()" href="#completed" role="tab" aria-controls="completed" aria-selected="true">
    <i class="feather-check mr-2 text-success mb-0"></i> Completed</a>
    </li>
    <li class="nav-item" role="presentation">
        <a   [ngClass]="[currentPage === 'Out Of Delivery' ? 'nav-link border-0 text-dark py-3 active' : 'nav-link border-0 text-dark py-3']"  id="outofdelivery-tab"  data-toggle="tab" (click)="outofdeliver()" href="#outofDelivery" role="tab" aria-controls="outofDelivery" aria-selected="true">
        <i class="feather-truck mr-2 text-default mb-0"></i> Out Of Delivery</a>
        </li>
    <li class="nav-item border-top" role="presentation">
    <a   [ngClass]="[currentPage === 'On Progress' ? 'nav-link border-0 text-dark py-3 active' : 'nav-link border-0 text-dark py-3']"  id="progress-tab" data-toggle="tab" (click)="progress()" href="#progress" role="tab" aria-controls="progress" aria-selected="false">
    <i class="feather-clock mr-2 text-warning mb-0"></i> On Progress</a>
    </li>
    <li class="nav-item border-top" role="presentation">
    <a   [ngClass]="[currentPage === 'Canceled' ? 'nav-link border-0 text-dark py-3 active' : 'nav-link border-0 text-dark py-3']" id="canceled-tab" data-toggle="tab" href="#canceled" (click)="cancel()" role="tab" aria-controls="canceled" aria-selected="false">
    <i class="feather-x-circle mr-2 text-danger mb-0"></i> Canceled</a>
    </li>
    </ul>
    </div>
    <div class="tab-content col-md-9" id="myTabContent" *ngIf="!showDetails && !showDetailsoutofdelivery && !showDetailsinprogress && !showDetailscancelled">
    <div class="tab-pane" [ngStyle]="{'display':completedtabdisplay}" id="completed" role="tabpanel" aria-labelledby="completed-tab">
    <div class="order-body"  *ngFor="let d of lstOrders;">
    <div class="pb-3">
    <div class="p-3 rounded shadow-sm bg-white" *ngIf="d.Status == 'Delivered' || 'Picked'">
    <div class="d-flex border-bottom pb-3">
   
    <div>
    <p class="mb-0 font-weight-bold"><a class="text-dark">Delivery Address:</a></p>
    <p class="mb-0">{{d.DeliveryAddress}}</p>
    <p>ORDER #{{d.OrderNumber}}</p>
    <p class="mb-0 small"><a class="viewdetails" (click)="showItemDetails(1,d)">View Details</a></p>
    </div>
    <div class="ml-auto">
    <p class="bg-success text-white py-1 px-2 rounded small mb-1">{{d.Status}}</p>
    <p class="small font-weight-bold text-center"><i class="feather-clock"></i> {{d.Date}}</p>
    </div>
    </div>
    <div class="pt-3">
        <div class="d-flex pt-3" *ngFor="let ordet of d.DeliveryDetails">
        <div class="text-muted mr-3" >
            <!-- <img alt="#" src="{{imagePath}}{{ordet.ProductImage}}" class="img-fluid order_img rounded"> -->
            <img alt="#" src="{{storeSettings.apiCallingUrl}}{{ordet.ProductImage}}" class="img-fluid order_img rounded">
        </div>
    <div class="small">
    <p class="text- font-weight-bold mb-0">{{ordet.ProductName}} x {{ordet.Qty}}</p>
    <h6 class="mt-2" *ngIf="ordet.Addons !=''">Addons:<span class="text- font-weight-bold mb-0">{{ordet.Addons}}</span></h6>
    <h6 *ngIf="ordet.Toppings !=''">Toppings:<span class="text- font-weight-bold mb-0">{{ordet.Toppings}}</span></h6>
    </div>
    </div>

    <div class="d-flex text-right">
        <div class="text-muted m-0 ml-auto mr-3 small">Total Amount<br>
        <span class="text-dark font-weight-bold">{{storeSettings.currency}}{{d.OrderNetTotal}}</span>
         </div>
    <a href="checkout.html" class="btn btn-primary px-3">Reorder</a>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>

    <div class="tab-pane" [ngStyle]="{'display':outofdeliverytabdisplay}" id="outofDelivery" role="tabpanel" aria-labelledby="outofdelivery-tab">
        <div class="order-body" *ngFor="let d of lstOrders;">
        <div class="pb-3">
        <div class="p-3 rounded shadow-sm bg-white" *ngIf="d.Status == 'Assigned' || 'In Route'">
        <div class="d-flex border-bottom pb-3">
       
        <div>
        <p class="mb-0 font-weight-bold"><a class="text-dark">Delivery Address:</a></p>
        <p class="mb-0">{{d.DeliveryAddress}}</p>
        <p>ORDER #{{d.OrderNumber}}</p>
        <p class="mb-0 small"><a class="viewdetails" (click)="showoutofDeliveryDetails(1,d)">View Details</a></p>
        </div>
        <div class="ml-auto">
        <p class="bg-success text-white py-1 px-2 rounded small mb-1">{{d.Status}}</p>
        <p class="small font-weight-bold text-center"><i class="feather-clock"></i> {{d.Date}}</p>
        </div>
        </div>
        <div class="pt-3">
            <div class="d-flex pt-3" *ngFor="let ordet of d.DeliveryDetails">
                <div class="text-muted mr-3" >
                    <!-- <img alt="#" src="{{imagePath}}{{ordet.ProductImage}}" class="img-fluid order_img rounded"> -->
                    <img alt="#" src="{{storeSettings.apiCallingUrl}}{{ordet.ProductImage}}" class="img-fluid order_img rounded">
                </div>
        <div class="small">
        <p class="text- font-weight-bold mb-0">{{ordet.ProductName}} x {{ordet.Qty}}</p>
        <h6 class="mt-2" *ngIf="ordet.Addons !=''">Addons:<span class="text- font-weight-bold mb-0">{{ordet.Addons}}</span></h6>
        <h6 *ngIf="ordet.Toppings !=''">Toppings:<span class="text- font-weight-bold mb-0">{{ordet.Toppings}}</span></h6>
        </div>
        </div>
        <div class="d-flex text-right">
        <div class="text-muted m-0 ml-auto mr-3 small">Total Amount<br>
        <span class="text-dark font-weight-bold">{{storeSettings.currency}}{{d.OrderNetTotal}}</span>
         </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>


    <div class="tab-pane show active" [ngStyle]="{'display':inprogresstabdisplay}" id="progress" role="tabpanel" aria-labelledby="progress-tab">
    <div class="order-body" *ngFor="let d of lstOrders;">
    <div class="pb-3" >
    <div class="p-3 rounded shadow-sm bg-white" *ngIf="d.Status == 'Open'">
    <div class="d-flex border-bottom pb-3">
    
    <div>
    <p class="mb-0 font-weight-bold"><a href="restaurant.html" class="text-dark">Delivery Address:</a></p>
    <p class="mb-0">{{d.DeliveryAddress}}</p>
    <p>ORDER #{{d.OrderNumber}}</p>
    <p class="mb-0 small"><a class="viewdetails" (click)="showinprogressDetails(1,d)">View Details</a></p>
    
    </div>
    <div class="ml-auto">
    <p class="bg-warning text-white py-1 px-2 rounded small mb-1">{{d.Status}}</p>
    <p class="small font-weight-bold text-center"><i class="feather-clock"></i> {{d.Date}}</p>
  
    </div>
    </div>
    <div class="pt-3">
        <div class="d-flex pt-3" *ngFor="let ordet of d.DeliveryDetails">
        <div class="text-muted mr-3" >
            <!-- <img alt="#" src="{{imagePath}}{{ordet.ProductImage}}" class="img-fluid order_img rounded"> -->
            <img alt="#" src="{{storeSettings.apiCallingUrl}}{{ordet.ProductImage}}" class="img-fluid order_img rounded">
        </div>
    <div class="small">
    <p class="text-font-weight-bold mb-0">{{ordet.ProductName}} x {{ordet.Qty}}</p>
    <h6 class="mt-2" *ngIf="ordet.Addons !=''">Addons:<span class="text- font-weight-bold mb-0">{{ordet.Addons}}</span></h6>
    <h6 *ngIf="ordet.Toppings !=''">Toppings:<span class="text- font-weight-bold mb-0">{{ordet.Toppings}}</span></h6>
    </div>
    </div>
    <div class="d-flex text-right">
          <div class="text-muted m-0 ml-auto mr-3 small" >Total Amount<br>
        <span class="text-dark font-weight-bold">{{storeSettings.currency}}{{d.OrderNetTotal}}</span>
        </div>
    <!-- <a  class="btn btn-primary px-3" (click)="showinprogressDetails(1,d)" style="color: #fff;">Track</a> -->
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>

    <div class="tab-pane" [ngStyle]="{'display':canceledtabdisplay}" id="canceled" role="tabpanel" aria-labelledby="canceled-tab">
    <div class="order-body" *ngFor="let d of lstOrders;">
    <div class="pb-3" *ngFor="let ordet of d.DeliveryDetails">
    <div class="p-3 rounded shadow-sm bg-white" *ngIf="d.Status == 'Canceled'">
    <div class="d-flex border-bottom pb-3">
     
    <div>
    <p class="mb-0 font-weight-bold"><a href="restaurant.html" class="text-dark">Delivery Address:</a></p>
    <p class="mb-0">{{d.DeliveryAddress}}</p>
    <p>ORDER #{{d.OrderNumber}}</p>
    <p class="mb-0 small"><a class="viewdetails" (click)="CancelledViewDetails(1,d)">View Details</a></p>
    </div>
    <div class="ml-auto">
    <p class="bg-danger text-white py-1 px-2 rounded small mb-1">{{d.Status}}</p>
    <p class="small font-weight-bold text-center"><i class="feather-clock"></i> {{d.Date}}</p>
    </div>
    </div>
    <div class="pt-3">
        <div class="d-flex pt-3" *ngFor="let ordet of d.DeliveryDetails">
        <div class="text-muted mr-3">
            <!-- <img alt="#" src="{{imagePath}}{{ordet.ProductImage}}" class="img-fluid order_img rounded"> -->
            <img alt="#" src="{{storeSettings.apiCallingUrl}}{{ordet.ProductImage}}" class="img-fluid order_img rounded">
        </div>
    <div class="small">
    <p class="text- font-weight-bold mb-0">{{ordet.ProductName}} x {{ordet.Qty}}</p>
    <h6 class="mt-2" *ngIf="ordet.Addons !=''">Addons:<span class="text- font-weight-bold mb-0">{{ordet.Addons}}</span></h6>
    <h6 *ngIf="ordet.Toppings !=''">Toppings:<span class="text- font-weight-bold mb-0">{{ordet.Toppings}}</span></h6>
    </div>
    </div>
    <div class="text-right">
    <div class="text-muted m-0 ml-auto mr-3 small text-right">Total Amount<br>
    <span class="text-dark font-weight-bold">{{storeSettings.currency}}{{d.OrderNetTotal}}</span>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>

     <!-- //view Details Start for delivered item -->

     <div class="col-md-9" *ngIf="showDetails">
        <section class="bg-white mechknow-main-body rounded shadow-sm overflow-hidden">
        <div class="container p-0">
        <div class="row">
        <div class="col-lg-12">
        <div class="mechknow-status">
        
        <div class="p-3 status-order bg-white border-bottom d-flex align-items-center">
        <p class="m-0"><i class="feather-calendar text-primary">{{Date}}</i></p>
        </div>
        <div class="p-3 border-bottom">
        <h6 class="font-weight-bold">Order Status</h6>
         <div class="tracking-wrap">
        <div class="my-1 step active">
        <span  [ngClass]="(Status=='Delivered' || 'Picked')?'icon text-success':'icon text-danger'"><i class="feather-check"></i></span>
        <span class="text small">Preparing order</span>
        </div>
        
        <!-- <div class="my-1 step active">
        <span [ngClass]="(d.Status=='Delivered')?'icon text-success':'icon text-danger'"><i class="feather-check"></i></span>
        <span class="text small"> Ready to collect</span>
        </div> -->
        
        <div class="my-1 step">
        <span [ngClass]="(Status=='Delivered'|| 'Picked')?'icon text-success':'icon text-danger'"><i class="feather-check"></i></span>
        <span class="text small"> On the way </span>
        </div>
        
        <div class="my-1 step">
        <span [ngClass]="(Status=='Delivered'|| 'Picked')?'icon text-success':'icon text-danger'"><i class="feather-check"></i></span>
        <span class="text small">Delivered Order</span>
        </div>
        
        </div>
        </div>
        
        <div class="p-3 border-bottom bg-white">
        <h6 class="font-weight-bold">Destination</h6>
        <p class="m-0 small">{{DeliveryAddress}}</p>
        </div>
        
        <div class="p-3 bg-white">
        <div class="d-flex align-items-center mb-2">
        <h6 class="font-weight-bold mb-1">Total Cost</h6>
        <h6 class="font-weight-bold ml-auto mb-1">{{storeSettings.currency}}{{OrderNetTotal}}</h6>
        </div>
        <!-- <p class="m-0 small text-muted">You can check your order detail here,<br>Thank you for order.</p> -->
        </div>
        </div>
        </div>
        </div>
        </div>
        </section>
        </div>
        <!-- view Details end -->
        <!-- //view Details Start for out of Delivery item -->
        <div class="col-md-9" *ngIf="showDetailsoutofdelivery">
            <section class="bg-white mechknow-main-body rounded shadow-sm overflow-hidden">
            <div class="container p-0">
            <div class="row">
            <div class="col-lg-12">
            <div class="mechknow-status">
            <div class="p-3 status-order border-bottom bg-white">
            <p class="small m-0"><i class="feather-calendar text-primary"></i> {{DateofDeliver}}</p>
            </div>
            <div class="p-3 border-bottom">
            <div class="d-flex">
            <h6 class="font-weight-bold">Order Status</h6>
            <!-- <span class="ml-auto"><a href="map.html" class="btn btn-primary">Track on map</a></span> -->
            </div>
            <div class="tracking-wrap">
            <div class="my-1 step active">
            <span [ngClass]="(StatusDeliver=='Assigned')?'icon text-success':'icon text-danger'"><i class="feather-check-circle"></i></span>
            <span class="text small">Preparing order</span>
            </div>
            <!-- <div class="my-1 step active">
            <span class="icon text-success"><i class="feather-check-circle"></i></span>
            <span class="text small">Ready to collect</span>
            </div> -->
            <div class="my-1 step">
            <span [ngClass]="(StatusDeliver=='Assigned')?'icon text-success':'icon text-danger'"><i class="feather-check-circle"></i></span>
            <span class="text small">On the way </span>
            </div>
            <div class="my-1 step">
            <span [ngClass]="(StatusDeliver=='Assigned')?'icon text-danger':'icon text-success'"><i class="feather-x-circle"></i></span>
            <span class="text small">Delivered Order</span>
            </div>
            </div>
            </div>
            <div class="p-3 border-bottom bg-white">
            <h6 class="font-weight-bold">Destination</h6>
            <p class="m-0 small">{{DeliverAddress}}</p>
            </div>
            <div class="p-3 border-bottom bg-white">
            <div class="d-flex align-items-center mb-2">
            <h6 class="font-weight-bold mb-1">Total Cost</h6>
            <h6 class="font-weight-bold ml-auto mb-1">{{storeSettings.currency}}{{totalAmount}}</h6>
            </div>
            <!-- <p class="m-0 small text-muted">You can check your order detail here,<br>Thank you for order.</p> -->
            </div>
            </div>
            </div>
            </div>
            </div>
            </section>
            </div>
            <!-- view Details end for out of Delivery  -->

            <!-- //view Details Start for inprogressy item -->
        <div class="col-md-9" *ngIf="showDetailsinprogress">
            <section class="bg-white mechknow-main-body rounded shadow-sm overflow-hidden">
            <div class="container p-0">
            <div class="row">
            <div class="col-lg-12">
            <div class="mechknow-status">
            <div class="p-3 status-order border-bottom bg-white">
            <p class="small m-0"><i class="feather-calendar text-primary"></i> {{progressDate}}</p>
            </div>
            <div class="p-3 border-bottom">
            <div class="d-flex">
            <h6 class="font-weight-bold">Order Status</h6>
            <!-- <span class="ml-auto"><a  class="btn btn-primary" style="color:#fff;" (click)="mapdetails(1)">Track on map</a></span> -->
            </div>
            <div class="tracking-wrap">
            <div class="my-1 step active">
            <span [ngClass]="(progressStatus=='Open')?'icon text-success':'icon text-danger'"><i class="feather-check-circle"></i></span>
            <span class="text small">Preparing order</span>
            </div>
            <!-- <div class="my-1 step active">
            <span class="icon text-danger"><i class="feather-x-circle"></i></span>
            <span class="text small">Ready to collect</span>
            </div> -->
            <div class="my-1 step">
            <span [ngClass]="(progressStatus=='Open')?'icon text-danger':'icon text-success'"><i class="feather-x-circle"></i></span>
            <span class="text small">On the way </span>
            </div>
            <div class="my-1 step">
            <span [ngClass]="(progressStatus=='Open')?'icon text-danger':'icon text-success'"><i class="feather-x-circle"></i></span>
            <span class="text small">Delivered Order</span>
            </div>
            </div>
            </div>
            <div class="p-3 border-bottom bg-white">
            <h6 class="font-weight-bold">Destination</h6>
            <p class="m-0 small">{{progressAddress}}</p>
            </div>
           
            <div class="p-3 border-bottom bg-white">
            <div class="d-flex align-items-center mb-2">
            <h6 class="font-weight-bold mb-1">Total Cost</h6>
            <h6 class="font-weight-bold ml-auto mb-1">{{storeSettings.currency}}{{progressAmount}}</h6>
            </div>
            <!-- <p class="m-0 small text-muted">You can check your order detail here,<br>Thank you for order.</p> -->
            </div>
            </div>
            </div>
            </div>
            </div>
            </section>
            </div>
            <!-- view Details end for inprogress  -->

            <!-- view Details Start for canceled  -->
            <div class="col-md-9" *ngIf="showDetailscancelled">

                <section class="bg-white mechknow-main-body rounded shadow-sm overflow-hidden">
                <div class="container p-0">
                <div class="row">
                <div class="col-lg-12">
                <div class="mechknow-status">
                
                <div class="p-3 status-order border-bottom bg-white">
                <p class="small m-0"><i class="feather-calendar text-primary"></i> {{cancelDate}}</p>
                </div>
                <div class="p-3 border-bottom">
                <h6 class="font-weight-bold">Order Status</h6>
                <div class="tracking-wrap">
                <div class="step active">
                 <span [ngClass]="(cancelStatus=='Canceled')?'icon text-success':'icon text-danger'"><i class="feather-check-circle"></i></span>
                <span class="text small">Ordered</span>
                </div>
                
                <div class="step active">
                <span [ngClass]="(cancelStatus=='Canceled')?'icon text-danger':'icon text-success'"><i class="feather-x-circle"></i></span>
                <span class="text small">Canceled</span>
                </div>
                
                </div>
                </div>
                
                <div class="p-3 border-bottom bg-white">
                <h6 class="font-weight-bold">Destination</h6>
                <p class="m-0 small">{{cancelAddress}}</p>
                </div>
               
                
                <div class="p-3 border-bottom bg-white">
                <div class="d-flex align-items-center mb-2">
                <h6 class="font-weight-bold mb-1">Total Cost</h6>
                <h6 class="font-weight-bold ml-auto mb-1">{{storeSettings.currency}}{{cancelAmount}}</h6>
                </div>
                <!-- <p class="m-0 small text-muted">You can check your order detail here,<br>Thank you for order.</p> -->
                </div>
                </div>
                </div>
                </div>
                </div>
                </section>
                </div>
                <!-- end Cancelled view Details   -->
 
    </div>  <!--row end -->
    </div> <!--Container end -->
    </section>